/**
 * deleteResumeEntry — ask the server to delete one list-section entry
 * (experience, education, project, award, certification) from a resume.
 *
 * The section forms remove entries from context state immediately; this
 * helper is what makes that removal survive Finish Up & Preview, which
 * re-reads the resume from the database.
 */

export const DELETE_ENTRY_URL = 'https://renaisons.com/api/delete_resume_entry.php';

// Entries created in the editor get a Date.now() id until their first
// successful save. save_*.php uses the same threshold to tell the two apart.
const TEMP_ID_FLOOR = 1000000000;

export function isPersistedEntryId(id) {
    if (id === null || id === undefined || id === '') return false;
    const n = Number(id);
    return Number.isInteger(n) && n > 0 && n < TEMP_ID_FLOOR;
}

export async function deleteResumeEntry({ section, id, resumeId }) {
    if (!isPersistedEntryId(id)) return { ok: true, skipped: true };
    try {
        const response = await fetch(DELETE_ENTRY_URL, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ section, id: Number(id), resume_id: resumeId }),
        });
        const result = await response.json();
        if (result && result.status === 'success') return { ok: true };
        return { ok: false, message: (result && result.message) || 'The entry was not deleted.' };
    } catch (e) {
        return { ok: false, message: 'Network error. The entry was not deleted.' };
    }
}
